module.exports = __webpack_public_path__ + "static/media/SKY.097b72c0.svg";